// extracted by mini-css-extract-plugin
export default {"informationView":"Delivery_informationView__djEBU","location":"Delivery_location__Rmjma"};